import { api } from "../../services/api";

export async function fetchDadosFinanceiro() {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem("@medusapayments:access_token");
    api
      .get("/compliance/finance", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}
